import { HttpClient }         from '@angular/common/http';
import { Injectable }         from '@angular/core';
import { AbstractApiService } from '@app/core/http/abstract-api.service';
import { SanitizerService }   from '@app/core/http/sanitizer.service';
import { TransitionService }  from '@app/core/http/transition.service';
import { IList }              from '@app/core/interfaces/list-response.interfaces';
import { ModelTypeEnum }      from '@app/core/models/transition.model';
import { ArchivingErs }       from '@app/modules/archiving/models/archiving-ers.model';
import { LoggerService }      from '@app/shared/services/logger.service';
import {
	IArchivingErsHttpParams,
	RequestCompleteListState
}                             from '@core/interfaces/api.interface';
import {
	ErsApiClient,
	ErsDTO,
	ListBusinessPremisesErsRequestParams
}                             from '@openApiGenerated/archiving-api';
import { Observable }         from 'rxjs';

@Injectable( {
	providedIn: 'root'
} )
export class ArchivingErsApiService extends AbstractApiService {

	constructor(
		protected http: HttpClient,
		protected logger: LoggerService,
		private readonly ersApiClient: ErsApiClient,
		private readonly sanitize: SanitizerService,
		private readonly transition: TransitionService
	) {
		super();
		this.http = http;
	}


	// SANITIZER ######################################
	private sanitizeApiResponse( entity: ArchivingErs, context = this ): void {
		if ( entity instanceof ArchivingErs ) {
			entity.created = context.sanitize.date<Date>( entity.created, ModelTypeEnum.TMO, Date );
		}
	}

	// SPECIFIC MAPPER ################################

	// LIST TYPE REQUESTS #############################
	public searchArchivingErsByBusinessPremisesId( params?: IArchivingErsHttpParams, throwError = false ): Observable<RequestCompleteListState<ArchivingErs>> {
		this.logger.trace( 'pre-searchArchivingErsByBusinessPremisesId call' );

		const requestParam: ListBusinessPremisesErsRequestParams = {
			businessPremisesId: params.businessPremisesId,
			pageSize: params?.paging?.pageSize,
			pageNumber: params?.paging?.pageNumber,
			sort: params?.sort,
			search: params?.search && params?.search.length > 0
							? params?.search[ 0 ]
							: undefined
		};

		const req$ = this.ersApiClient.listBusinessPremisesErs( requestParam );

		return this.transition.handleListRequestResponse<ErsDTO, ArchivingErs>(
			req$ as Observable<IList<ErsDTO>>,
			ArchivingErs,
			this,
			this.sanitizeApiResponse,
			null,
			null,
			throwError
		);
	}

	// ENTITY TYPE REQUESTS ###########################
}
